module.exports = __webpack_public_path__ + "1b61a6bdb2815f5d85870f48cd2f4e96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_150.jpg
// module id = 1664
// module chunks = 5